'use strict';
/* ================================================================
   DRP Media — Customizer Pricing Engine
   All amounts in CENTS (integer). No floating-point money math.

   Pricing model:
     per-unit price  = garment_cents + print_fee_per_unit
     order total     = (per-unit × qty) + setup_fee + color_sep_fee

   Setup fee and color separation are ONE-TIME per order.
   Print fee is charged PER UNIT.
   ================================================================ */
(function () {

  /* ── Price tables (all values in cents) ─────────────────────── */
  var METHODS = {
    'Screen Printing': {
      setupFee:          4500,   // $45.00 — screen charge,    one-time per order
      colorFeePerColor:  1500,   // $15.00 per color — color separation, one-time
      minQty:            24,
      perUnit: {
        small:    500,   // $5.00  — Small  (4")
        medium:   650,   // $6.50  — Medium (8")
        large:    850,   // $8.50  — Large  (12")
        full:    1200,   // $12.00 — Full / custom
      },
    },
    'DTF': {
      setupFee:           0,
      colorFeePerColor:   0,
      minQty:             1,
      perUnit: {
        small:    350,   // $3.50
        medium:   550,   // $5.50
        large:    900,   // $9.00
        full:    1400,   // $14.00
      },
    },
    'Embroidery': {
      setupFee:          3000,   // $30.00 — digitizing fee, one-time
      colorFeePerColor:     0,
      minQty:              12,
      perUnit: {
        small:    600,   // $6.00
        medium:   900,   // $9.00
        large:   1200,   // $12.00
        full:    1500,   // $15.00
      },
    },
    'Vinyl': {
      setupFee:           0,
      colorFeePerColor:   0,
      minQty:             1,
      perUnit: {
        small:    500,   // $5.00
        medium:   800,   // $8.00
        large:   1200,   // $12.00
        full:    1800,   // $18.00
      },
    },
  };

  /* ── Accessors ───────────────────────────────────────────────── */
  function getConfig(method) {
    return METHODS[method] || null;
  }

  function getPrintFeePerUnit(method, sizeKey) {
    var cfg = getConfig(method);
    if (!cfg) return 0;
    return cfg.perUnit[sizeKey] || cfg.perUnit.medium;
  }

  function getSetupFee(method) {
    var cfg = getConfig(method);
    return cfg ? cfg.setupFee : 0;
  }

  function getColorFee(method, numColors) {
    var cfg = getConfig(method);
    if (!cfg || !cfg.colorFeePerColor) return 0;
    return cfg.colorFeePerColor * Math.max(1, parseInt(numColors, 10) || 1);
  }

  /* Per-unit price (garment + print fee) */
  function getPerUnitPrice(garmentCents, method, sizeKey) {
    return garmentCents + getPrintFeePerUnit(method, sizeKey);
  }

  /* Grand total: (per-unit × qty) + one-time fees */
  function getTotal(garmentCents, method, sizeKey, qty, numColors) {
    var unitPrice = getPerUnitPrice(garmentCents, method, sizeKey);
    var setupFee  = getSetupFee(method);
    var colorFee  = getColorFee(method, numColors);
    return (unitPrice * Math.max(1, qty || 1)) + setupFee + colorFee;
  }

  /* Compat entry-point used by customizer.js */
  function getCustomizedPrice(garmentCents, method, sizeKey, qty, numColors) {
    if (!method) return Math.round(garmentCents * 1.20); // fallback until method is chosen
    return getTotal(garmentCents, method, sizeKey, qty, numColors);
  }

  /* ── Formatting ──────────────────────────────────────────────── */
  function fmt(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      var format = (window.DRP_CUSTOMIZER || {}).moneyFormat || '{{amount}}';
      return window.Shopify.formatMoney(cents, format);
    }
    return 'CA$' + (cents / 100).toFixed(2);
  }

  /* ── Breakdown renderer ──────────────────────────────────────── */
  /*
   * state = {
   *   method:    string   e.g. 'Screen Printing'
   *   sizeKey:   string   e.g. 'large'
   *   printSize: string   e.g. 'Large (12")'
   *   qty:       number
   *   numColors: number   (1 default; used by Screen Printing)
   * }
   */
  function renderBreakdown(el, garmentCents, isCustomize, state) {
    if (!el) return;
    if (!isCustomize) { el.innerHTML = ''; return; }

    var method    = (state && state.method)    ? state.method    : '';
    var sizeKey   = (state && state.sizeKey)   ? state.sizeKey   : '';
    var printSize = (state && state.printSize) ? state.printSize : '';
    var qty       = Math.max(1, (state && state.qty)       ? parseInt(state.qty, 10) || 1       : 1);
    var numColors = Math.max(1, (state && state.numColors) ? parseInt(state.numColors, 10) || 1 : 1);

    if (!method) {
      el.innerHTML = '<p class="cust-price-note">Select a print method to see pricing.</p>';
      return;
    }

    var printFee  = sizeKey ? getPrintFeePerUnit(method, sizeKey) : 0;
    var unitPrice = garmentCents + printFee;
    var setupFee  = getSetupFee(method);
    var colorFee  = getColorFee(method, numColors);
    var subtotal  = unitPrice * qty;
    var total     = subtotal + setupFee + colorFee;

    var html = '<div class="cust-price-breakdown">';

    /* Row 1 — per-unit × qty */
    html += '<div class="cust-price-row">';
    if (printFee > 0) {
      var sizeLabel = printSize ? ' (' + printSize + ')' : '';
      html += '<span class="cust-price-row__label">'
            + fmt(garmentCents) + ' garment + '
            + fmt(printFee) + ' print' + sizeLabel
            + ' = ' + fmt(unitPrice) + ' × ' + qty + ' units'
            + '</span>';
    } else {
      html += '<span class="cust-price-row__label">' + fmt(garmentCents) + ' × ' + qty + ' units</span>';
    }
    html += '<span class="cust-price-row__amount">' + fmt(subtotal) + '</span>';
    html += '</div>';

    /* Row 2 — setup fee (one-time) */
    if (setupFee > 0) {
      html += '<div class="cust-price-row cust-price-row--onetime">';
      html += '<span class="cust-price-row__label">One-time setup fee</span>';
      html += '<span class="cust-price-row__amount">+ ' + fmt(setupFee) + '</span>';
      html += '</div>';
    }

    /* Row 3 — color separation (one-time, screen printing only) */
    if (colorFee > 0) {
      var cfg = getConfig(method);
      var perColor = cfg ? cfg.colorFeePerColor : 0;
      var colorLabel = numColors + ' color' + (numColors === 1 ? '' : 's') + ' × ' + fmt(perColor);
      html += '<div class="cust-price-row cust-price-row--onetime">';
      html += '<span class="cust-price-row__label">Color separation (' + colorLabel + ')</span>';
      html += '<span class="cust-price-row__amount">+ ' + fmt(colorFee) + '</span>';
      html += '</div>';
    }

    /* Total row */
    html += '<div class="cust-price-row cust-price-row--total">';
    html += '<span class="cust-price-row__label">Order Total</span>';
    html += '<span class="cust-price-row__amount">' + fmt(total) + '</span>';
    html += '</div>';

    html += '</div>';
    el.innerHTML = html;
  }

  /* ── Public API ──────────────────────────────────────────────── */
  window.CustPricing = {
    METHODS:             METHODS,
    getCustomizedPrice:  getCustomizedPrice,
    getPerUnitPrice:     getPerUnitPrice,
    getTotal:            getTotal,
    getSetupFee:         getSetupFee,
    getColorFee:         getColorFee,
    getPrintFeePerUnit:  getPrintFeePerUnit,
    renderBreakdown:     renderBreakdown,
    fmt:                 fmt,
  };
})();
